export default __webpack_public_path__ + "static/media/ldo_ADJ_BIAS_nEN_Cff.a47ba96c.svg";